import {Component} from '@angular/core';

@Component({
    selector: 'vui-panel-actions',
    templateUrl: './panel-actions.component.html'
})
export class PanelActionsComponent {

}
